(function () {
    'use strict';

    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtIssueOrderProxy', PmtIssueOrderProxy);

    PmtIssueOrderProxy.$inject = ['$http', '$q', 'localStorageService', 'CommonsCookiesService', 'CommonsLoginConstants'];

    function PmtIssueOrderProxy($http, $q, localStorageService, CommonsCookiesService, CommonsLoginConstants) {
        var service = {
            issueOrder: issueOrder,
            getIssueInfoBy3dsPay: getIssueInfoBy3dsPay
        };

        return service;

        ////////////////
        /**
         * Calls HTTP  method on the issue order rest service with the request data with the payment information
         * @param {string} url - the http url of issue order rest service
         * @param {Object} requestData - the request form data to call the webservice with the orderId, orderItemsId, paymentId and paymentMethod
         * @param {boolean} isRecall - param to determinate the kind of the call
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function issueOrder(url, requestData, isRecall) {
            const SF_Headers = {
                headers: {
                    'X-Salesforce-Token': localStorageService.get('loginSF') || CommonsCookiesService.getCookie(CommonsLoginConstants.SSO_COOKIES.SF_LOGGED_TOKEN)
                }
            };
            return isRecall ? $http.put(url, angular.toJson(requestData), localStorageService.get('userLogged') === true ? SF_Headers : null)
                .then(getTicketsComplete)['catch'](getTicketsFailed) : $http.post(url, angular.toJson(requestData), localStorageService.get('userLogged') === true ? SF_Headers : null)
                    .then(getTicketsComplete)['catch'](getTicketsFailed);

            function getTicketsComplete(response) {
                return { data: response.data, code: response.status };
            }

            function getTicketsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        };

        /**
         * Calls HTTP GET method to the obtain the issue info for a booking purchase
         * @param {string} url - the http url of the issue info rest service
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function getIssueInfoBy3dsPay(url) {
            const SF_Headers = {
                headers: {
                    'X-Salesforce-Token': localStorageService.get('loginSF') || CommonsCookiesService.getCookie(CommonsLoginConstants.SSO_COOKIES.SF_LOGGED_TOKEN)
                }
            };
            return $http.get(url, localStorageService.get('userLogged') === true ? SF_Headers : null).then(issueInfoComplete)['catch'](issueInfoFailed);

            function issueInfoComplete(response) {
                return { data: response.data, code: response.status };
            }

            function issueInfoFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();
